/**
 * Copyright IBM Corp. 2023
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TriImageSkeleton = ( { className, ...other } ) =>
{
  const skeletonPlaceholderClasses = classNames( {
    [ "TriImageSkeleton" ]: true,
    [ className ]: className,
  } );

  return <div className={ skeletonPlaceholderClasses }
    { ...other }
  />;
};

TriImageSkeleton.propTypes = {
  className: PropTypes.string,
};

export default TriImageSkeleton;
